module.exports = __webpack_public_path__ + "static/media/compress-wide.93c2d80d.svg";